
import store from "../../../../infrastructure/repository/store/store";
import {defineComponent, onMounted, PropType, watch} from "vue";

class Span {
  public message: string;
  public changed: boolean;

  constructor(message = "", changed = false) {
    this.changed = changed;
    this.message = message;
  }
}
export default defineComponent({
  props: {
    success: {
      type: Object as PropType<Span>,
      required: true,
    },
  },

  setup(props) {
    onMounted(() => {
      const box = document.querySelector(
        "[data-success-box]"
      ) as HTMLDivElement;
      box.addEventListener("animationend", () => {
        if (box.classList.contains("open")) {
          box.classList.remove("open");
          box.classList.add("close");

          store.dispatch("miscellany_module/setSuccess", {
            message: props.success?.message,
            changed: false,
          });
        }
      });
    });

    watch(
      () => props.success?.changed,
      () => {
        if (props.success?.changed) {
          const box = document.querySelector(
            "[data-success-box]"
          ) as HTMLDivElement;
          box.classList.add("open");
        }
      }
    );
  },
});
